(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9271],{

/***/ 9271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ MainHome; }
});

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/Footer/Footer.jsx + 2 modules
var Footer = __webpack_require__(835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(5827);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5258);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(5602);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(950);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(131);
// EXTERNAL MODULE: ./hooks/useCollection.js
var useCollection = __webpack_require__(2126);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(1766);
// EXTERNAL MODULE: ./services/helper.js + 180 modules
var helper = __webpack_require__(7925);
;// CONCATENATED MODULE: ./hooks/useStoreProducts.js






var fetchProducts = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var queryKey, _ref$pageParam, pageParam, _queryKey, storeId, collection, url, response, data;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queryKey = _ref.queryKey, _ref$pageParam = _ref.pageParam, pageParam = _ref$pageParam === void 0 ? 1 : _ref$pageParam;
            _queryKey = (0,slicedToArray/* default */.Z)(queryKey, 3), storeId = _queryKey[1], collection = _queryKey[2];
            url = "".concat(helper/* publicServerEndpoint */.v2, "/v3/product/store/").concat(storeId, "/collectionv2?page=").concat(pageParam, "&limit=", 20, "&source=web");

            if (collection && collection !== "all") {
              url += "&collectionId=".concat(collection);
            }

            _context.next = 6;
            return fetch(url);

          case 6:
            response = _context.sent;

            if (response.ok) {
              _context.next = 9;
              break;
            }

            throw new Error("Failed to fetch products");

          case 9:
            _context.next = 11;
            return response.json();

          case 11:
            data = _context.sent;
            return _context.abrupt("return", {
              products: data.data.docs,
              nextPage: pageParam + 1,
              previousPage: pageParam > 1 ? pageParam - 1 : null,
              hasNextPage: data.data.hasNextPage
            });

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchProducts(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useStoreProducts = function useStoreProducts(storeId, collection) {
  return (0,useInfiniteQuery/* useInfiniteQuery */.N)(["storeProducts", storeId, collection], fetchProducts, {
    getNextPageParam: function getNextPageParam(lastPage) {
      return lastPage.hasNextPage ? lastPage.nextPage : undefined;
    },
    cacheTime: 30 * 1000,
    staleTime: 30 * 1000,
    keepPreviousData: true,
    enabled: !!storeId
  });
};

/* harmony default export */ var hooks_useStoreProducts = (useStoreProducts);
// EXTERNAL MODULE: ./pages/500.js
var _500 = __webpack_require__(7486);
// EXTERNAL MODULE: ./services/frontend/CartStorage.js + 1 modules
var CartStorage = __webpack_require__(5579);
// EXTERNAL MODULE: ./components/Cart/Basket.jsx + 1 modules
var Basket = __webpack_require__(3388);
// EXTERNAL MODULE: ./components/EmptyStore.jsx + 1 modules
var EmptyStore = __webpack_require__(8272);
// EXTERNAL MODULE: ./components/Navbar/index.jsx + 1 modules
var Navbar = __webpack_require__(8053);
// EXTERNAL MODULE: ./components/SideNavDrawer.jsx + 2 modules
var SideNavDrawer = __webpack_require__(6121);
// EXTERNAL MODULE: ./components/Skeleton.jsx
var Skeleton = __webpack_require__(2463);
// EXTERNAL MODULE: ./components/SkeletonCard.jsx
var SkeletonCard = __webpack_require__(3101);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/CollectionFilter.jsx



var CollectionFilter = function CollectionFilter(_ref) {
  var collection = _ref.collection,
      selectedCollection = _ref.selectedCollection,
      setFilter = _ref.setFilter,
      theme = _ref.theme;
  //console.log("CollectionFilter ", collection.name, selectedCollection.name);
  var isSelected = (collection === null || collection === void 0 ? void 0 : collection.name) === (selectedCollection === null || selectedCollection === void 0 ? void 0 : selectedCollection.name);

  var handleClick = function handleClick() {
    if (!isSelected) {
      console.log("set filter ", collection);
      setFilter(collection);
    }
  };

  var isThemePresent = !!(theme !== null && theme !== void 0 && theme.primaryColor) && !!(theme !== null && theme !== void 0 && theme.backgroundColor);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "m-[4px_5px_5px_4px] flex h-[40px] select-none items-center justify-center whitespace-nowrap rounded-[20px] px-5 text-[13px] capitalize tracking-[1px] ".concat(isSelected ? "text-fontPrimary bg-primary" : isThemePresent ? "text-fontBackground bg-secondary" : "text-fontBackground bg-appGray"),
    onClick: handleClick,
    children: collection.name ? collection.name : "All Products"
  });
};

/* harmony default export */ var components_CollectionFilter = (CollectionFilter);
;// CONCATENATED MODULE: ./components/StoreCollections.jsx






var StoreCollections = function StoreCollections(_ref) {
  var collections = _ref.collections,
      setFilter = _ref.setFilter,
      selectedCollection = _ref.selectedCollection,
      theme = _ref.theme;
  var router = (0,next_router.useRouter)();
  var collectionRefs = (0,react.useRef)({});
  var storeCollections = (0,react.useMemo)(function () {
    var list = []; // Add "All Products" pill with ref

    list.push( /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      ref: function ref(el) {
        collectionRefs.current["all-products"] = el;
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_CollectionFilter, {
        collection: CollectionHome_ALL_PRODUCTS_OBJECT,
        selectedCollection: selectedCollection,
        setFilter: setFilter,
        theme: theme
      })
    }, "initial")); // Add collection pills with refs

    var collectionList = collections.map(function (collection) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        ref: function ref(el) {
          var _collection$name;

          collectionRefs.current[(_collection$name = collection.name) === null || _collection$name === void 0 ? void 0 : _collection$name.toLowerCase()] = el;
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_CollectionFilter, {
          collection: collection,
          selectedCollection: selectedCollection,
          setFilter: setFilter,
          theme: theme
        })
      }, collection._id);
    });
    return list.concat(collectionList);
  }, [collections, selectedCollection, setFilter]); // Handle scroll to active collection on URL change

  (0,react.useEffect)(function () {
    var collectionParam = router.query.collection;

    if (collectionParam) {
      var targetKey = collectionParam.toLowerCase();
      var targetRef = collectionRefs.current[targetKey];

      if (targetRef) {
        setTimeout(function () {
          targetRef.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest"
          });
        }, 100);
      }
    }
  }, []);
  return collections.length ? storeCollections : null;
};

/* harmony default export */ var components_StoreCollections = (StoreCollections);
// EXTERNAL MODULE: ./components/StoreItem.jsx + 1 modules
var StoreItem = __webpack_require__(2141);
// EXTERNAL MODULE: ./components/Home/RestorableList.jsx
var RestorableList = __webpack_require__(7861);
// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(1033);
;// CONCATENATED MODULE: ./components/Home/CollectionHome.jsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






















var CollectionHome_ALL_PRODUCTS_OBJECT = {
  name: "all products",
  _id: "all"
};

var CollectionHome = function CollectionHome(_ref) {
  var _cart$products;

  var store = _ref.store,
      theme = _ref.theme;
  var router = (0,next_router.useRouter)();
  var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();

  var _useState = (0,react.useState)(CollectionHome_ALL_PRODUCTS_OBJECT),
      selectedCollection = _useState[0],
      setSelectedCollection = _useState[1];

  var _useState2 = (0,react.useState)(null),
      lastEl = _useState2[0],
      setLastEl = _useState2[1];

  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)({
    threshold: 0
  }),
      ref = _useInView.ref,
      inView = _useInView.inView;

  var _useStoreProducts = hooks_useStoreProducts(store.id, selectedCollection === null || selectedCollection === void 0 ? void 0 : selectedCollection._id),
      productData = _useStoreProducts.data,
      isProductsLoading = _useStoreProducts.isLoading,
      isFetchingNextPage = _useStoreProducts.isFetchingNextPage,
      fetchNextPage = _useStoreProducts.fetchNextPage,
      hasNextPage = _useStoreProducts.hasNextPage,
      productError = _useStoreProducts.error;

  var _useCollection = (0,useCollection/* default */.Z)(store.id, ""),
      collectionsData = _useCollection.data,
      isCollectionsLoading = _useCollection.isLoading,
      collectionsError = _useCollection.error; // Assuming collectionsData is now structured as { collections: [...] }


  var collections = collectionsData ? collectionsData.collections : []; //console.log("shubham", collectionsData);
  // eslint-disable-next-line react-hooks/exhaustive-deps

  var products = (productData === null || productData === void 0 ? void 0 : productData.pages.flatMap(function (page) {
    return page.products;
  })) || [];

  var _useState3 = (0,react.useState)(CartStorage/* default.getInitialCart */.Z.getInitialCart()),
      cart = _useState3[0],
      setCart = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      showCart = _useState4[0],
      setShowCart = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      showSideNav = _useState5[0],
      setShowSideNav = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isCartInitialized = _useState6[0],
      setIsCartInitialized = _useState6[1]; // Initialize cart from CartStorage when component mounts


  (0,react.useEffect)(function () {
    var initialize = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var initialCartData;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return CartStorage/* default.initializeCart */.Z.initializeCart();

              case 2:
                initialCartData = _context.sent;
                setCart(initialCartData);
                setIsCartInitialized(true);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function initialize() {
        return _ref2.apply(this, arguments);
      };
    }();

    initialize();
  }, []); // Update CartStorage when cart changes

  (0,react.useEffect)(function () {
    if (cart !== CartStorage/* default.getInitialCart */.Z.getInitialCart()) {
      CartStorage/* default.saveCart */.Z.saveCart(cart);
    }
  }, [cart]);
  var handleShowCart = (0,react.useCallback)(function () {
    var boolVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (isCollectionsLoading || collectionsError || productError) return;
    setShowCart(boolVal);
  }, [isCollectionsLoading, collectionsError, productError]);
  (0,react.useEffect)(function () {
    var queryCollection = router.query.collection;

    if (queryCollection) {
      var foundCollection = collections.find(function (c) {
        return c.name.trim().toLowerCase() === queryCollection.trim().toLowerCase();
      });
      setSelectedCollection(foundCollection);
    } else {
      setSelectedCollection(CollectionHome_ALL_PRODUCTS_OBJECT);
    }
  }, [collections, router.query]);
  var setFilter = (0,react.useCallback)(function (collection) {
    queryClient.invalidateQueries(["storeProducts", store.id, collection]);
    queryClient.removeQueries(["storeProducts", store.id, selectedCollection]);
    setSelectedCollection(collection);
    router.push({
      pathname: router.pathname,
      query: _objectSpread(_objectSpread({}, router.query), {}, {
        collection: collection.name === "all products" ? "" : collection.name
      })
    }, undefined, {
      shallow: true
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [router]);
  (0,react.useEffect)(function () {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, isFetchingNextPage, fetchNextPage]);
  (0,react.useEffect)(function () {
    if (!products.length) return;

    var _products$slice = products.slice(-1),
        _products$slice2 = (0,slicedToArray/* default */.Z)(_products$slice, 1),
        lastElement = _products$slice2[0];

    setLastEl(lastElement.id);
  }, [products]);

  var updateAndSaveCart = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(newCartData) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setCart(newCartData);
              _context2.next = 3;
              return CartStorage/* default.saveCart */.Z.saveCart(newCartData);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function updateAndSaveCart(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var updateAddedToCart = function updateAddedToCart(productId, value) {
    console.log("Product ".concat(productId, " added status: ").concat(value, " (update logic needed here if applicable)"));
  };

  if (collectionsError || productError) return /*#__PURE__*/(0,jsx_runtime.jsx)(_500["default"], {});
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "scrollbar-none mt-[38px] min-h-[calc(100vh-268px)] w-full px-[22px]",
    children: [isCartInitialized && (cart === null || cart === void 0 ? void 0 : (_cart$products = cart.products) === null || _cart$products === void 0 ? void 0 : _cart$products.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Basket/* default */.Z, {
      isBasketOpen: showCart,
      setCart: updateAndSaveCart,
      cartData: cart,
      updateAddedToCart: updateAddedToCart,
      handleShowCart: handleShowCart,
      store: store,
      setRefresh: function setRefresh() {}
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar/* default */.Z, {
      cartActive: cart.products.length > 0,
      handleShowCart: handleShowCart,
      hideInAdvance: false,
      homeActive: false,
      store: store,
      theme: theme,
      storeName: (store === null || store === void 0 ? void 0 : store.storeName) || "",
      toggleSideNav: function toggleSideNav() {
        return setShowSideNav(!showSideNav);
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SideNavDrawer/* default */.Z, {
      isOpen: showSideNav,
      toggleDrawer: function toggleDrawer() {
        return setShowSideNav(!showSideNav);
      },
      store: store
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: isCollectionsLoading || collections && collections.length > 0 ? "hide-scrollbar relative left-0 right-0 top-14 z-10 mt-[5px] flex h-12 max-w-[500px] overflow-x-auto overflow-y-hidden scroll-smooth px-0 leading-8" : "",
      children: [collections && collections.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_StoreCollections, {
        theme: theme,
        collections: collections,
        setFilter: setFilter,
        selectedCollection: selectedCollection
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "h-5"
      }), isCollectionsLoading && Array(3).fill(0).map(function (_, i) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
          className: "m-[4px_5px_5px_4px] w-[150px] rounded-[50px] px-5 py-[4px]"
        }, i);
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative mt-4 grid min-h-[80vh] gap-[11px_22px] pt-16",
      children: [products.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(RestorableList/* default */.Z, {
        children: react.Children.toArray(products.map(function (_, index) {
          var startIndex = index * 2;
          var endIndex = startIndex + 2;
          var rowProducts = products.slice(startIndex, endIndex);
          if (!rowProducts.length) return null;
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "grid grid-cols-2 gap-4",
            children: react.Children.toArray(rowProducts.map(function (product) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                ref: lastEl === product.id ? ref : null,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(StoreItem/* default */.Z, {
                  cohort: store.cohort.includes(2) ? store.cohort : null,
                  product: product,
                  top: index === 0
                })
              });
            }))
          });
        }))
      }) : !isProductsLoading && /*#__PURE__*/(0,jsx_runtime.jsx)(EmptyStore/* default */.Z, {
        store: store
      }), (isFetchingNextPage || isProductsLoading) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-2 gap-4",
        children: Array(6).fill(0).map(function (_, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(SkeletonCard/* default */.Z, {
              imageClass: "rounded-lg object-cover max-w-[none] w-[calc((100vw/2)-33px)] h-[calc((100vw/2)-33px)] md:w-[calc((520px/2)-33px)] md:h-[calc((520px/2)-33px)]",
              titleClass: "h-4 w-[calc((100vw/2)-33px)] md:w-[calc((520px/2)-33px)]",
              descriptionClass: "h-4 w-[calc((100vw/2)-150px)] md:w-[calc((520px/2)-150px)]",
              containerClass: "flex justify-start items-start flex-col max-w-[calc((100vw/2)-33px)] mb-8 md:max-w-[calc((520px/2)-33px)]"
            }, i)
          }, i);
        })
      })]
    })]
  });
};

/* harmony default export */ var Home_CollectionHome = (CollectionHome);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(2933);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(2004);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(615);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/styles/carousel.min.css
var carousel_min = __webpack_require__(6703);
// EXTERNAL MODULE: ./lib/utils.js
var utils = __webpack_require__(7756);
// EXTERNAL MODULE: ./components/Infobanner/static-infobanner.module.css
var static_infobanner_module = __webpack_require__(3405);
var static_infobanner_module_default = /*#__PURE__*/__webpack_require__.n(static_infobanner_module);
;// CONCATENATED MODULE: ./components/Infobanner/StaticInfoBanner.jsx




function StaticInfoBanner(_ref) {
  var text = _ref.text;
  if (text) return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "relative",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: (0,utils.cn)((static_infobanner_module_default()).infobanner, "!bg-primary !text-fontPrimary"),
      children: text
    })
  });
  return null;
}
// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(2679);
// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/src/effects/blur.css
var effects_blur = __webpack_require__(8893);
;// CONCATENATED MODULE: ./components/SectionHeading.jsx



var SectionHeading = function SectionHeading(_ref) {
  var label = _ref.label,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
    className: (0,utils.cn)("bg-ap text-fontBackground text-center text-2xl font-bold", className),
    children: label
  });
};

/* harmony default export */ var components_SectionHeading = (SectionHeading);
;// CONCATENATED MODULE: ./components/Reviews/Reviews.jsx






 // type Review = {
//   _id: string;
//   storeId: string;
//   link?: string;
//   title?: string;
//   rating?: number;
//   image?: string;
//   sortOrder?: number;
//   createdAt: string;
//   updatedAt: string;
// };
// interface ReviewsProps {
//   storeId: string;
// }




var Reviews = function Reviews(_ref) {
  var storeId = _ref.storeId;

  var _useState = (0,react.useState)([]),
      reviews = _useState[0],
      setReviews = _useState[1];

  var _useState2 = (0,react.useState)(true),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var sortedReviews = reviews.sort(function (a, b) {
    return a.sortOrder - b.sortOrder;
  });
  var renderSkeletons = Array(6).fill(0).map(function (_, i) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ReviewSkeleton, {}, i);
  });
  var renderReviews = sortedReviews.map(function (review) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(build.LazyLoadImage, {
        className: "h-[432px] min-w-[250px] rounded-2xl object-cover",
        src: review.image,
        alt: review.title || "Review Image",
        effect: "blur"
      })
    }, review._id);
  });
  (0,react.useEffect)(function () {
    var fetchReviews = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var response, data;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setIsLoading(true);
                _context.prev = 1;
                _context.next = 4;
                return fetch("".concat(helper/* publicServerEndpoint */.v2, "/v2/review/store/").concat(storeId));

              case 4:
                response = _context.sent;
                _context.next = 7;
                return response.json();

              case 7:
                data = _context.sent;
                setReviews(data.data);
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);
                console.error("Error fetching reviews:", _context.t0);
                setReviews([]);

              case 15:
                _context.prev = 15;
                setIsLoading(false);
                return _context.finish(15);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 11, 15, 18]]);
      }));

      return function fetchReviews() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchReviews(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (sortedReviews.length === 0) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "mt-[50px] pl-[20px] pr-[27px]",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_SectionHeading, {
      label: "Reviews"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hide-scrollbar mt-[30px] flex gap-x-5 overflow-x-auto",
      children: isLoading ? renderSkeletons : renderReviews
    })]
  });
};

var ReviewSkeleton = function ReviewSkeleton() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "h-[432px] min-w-[250px] animate-pulse rounded-2xl bg-gray-200"
  });
};

/* harmony default export */ var Reviews_Reviews = (Reviews);
// EXTERNAL MODULE: ./components/Home/featured-home.module.css
var featured_home_module = __webpack_require__(3046);
var featured_home_module_default = /*#__PURE__*/__webpack_require__.n(featured_home_module);
;// CONCATENATED MODULE: ./components/Home/FeaturedCollectionList.jsx

 // type Collection = {
//       _id: string;
//       name: string;
//       createdAt: string;
//       updatedAt: string;
//       sortOrder: number;
//       store: string;
//       isFeatured: boolean;
//       isActive: boolean;
//     }
// interface FeaturedCollectionListProps {
//   featuredCollections: Collection[];
//   isLoading: boolean;
// }




var FeaturedCollectionList = function FeaturedCollectionList(_ref) {
  var featuredCollections = _ref.featuredCollections,
      isLoading = _ref.isLoading;
  var renderSkeletons = Array(4).fill(0).map(function (_, index) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(FeaturedCollectionList_SkeletonCard, {}, index);
  });
  var renderCollections = featuredCollections.map(function (collection) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(FeaturedCollectionCard, {
      collection: collection
    }, collection._id);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "mt-[50px] pl-[20px] pr-[27px]",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_SectionHeading, {
      label: "Featured Collections"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mt-[30px] grid grid-cols-2 gap-x-[19px] gap-y-[36px]",
      children: isLoading ? renderSkeletons : renderCollections
    })]
  });
};

/* harmony default export */ var Home_FeaturedCollectionList = (FeaturedCollectionList);

var FeaturedCollectionCard = function FeaturedCollectionCard(_ref2) {
  var collection = _ref2.collection;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    onClick: function onClick() {
      return router.push("/shop?collection=".concat(collection.name));
    },
    className: "cursor-pointer",
    children: [collection.image ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      src: collection.image,
      alt: "collection image",
      className: "h-[162px] w-full rounded-lg object-cover md:h-[227px]"
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "h-[162px] w-full rounded-lg bg-gray-200 md:h-[227px]"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "mt-1 text-base font-normal text-fontBackground opacity-80",
      children: collection.name
    })]
  });
};

var FeaturedCollectionList_SkeletonCard = function SkeletonCard() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "h-[162px] w-full rounded-lg bg-gray-200 md:h-[227px]"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mt-1 h-6 w-24 bg-gray-200"
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Home/FeaturedCollectionWithProd.jsx






function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
/**
 * Component to display a collection with its products in a horizontal scrollable list
 *
 * @param {Object} props - Component props
 * @param {Array} props.cohort - Store cohort information
 * @param {string} props.collectionName - Name of the collection
 * @param {Array} props.productsData - Array of products in the collection
 */


var FeaturedCollectionWithProd = function FeaturedCollectionWithProd(_ref) {
  var cohort = _ref.cohort,
      collectionName = _ref.collectionName,
      productsData = _ref.productsData,
      themeData = _ref.themeData;
  var products = productsData || [];

  if (products.length === 0) {
    return null;
  }

  var formattedCollectionName = capitalizeFirstLetter(collectionName ? collectionName : "");
  var collectionUrl = "/shop?collection=".concat(encodeURIComponent(collectionName));
  var isVerticalScroll = (themeData === null || themeData === void 0 ? void 0 : themeData.collectionScrollDirection) === "vertical";
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "m-5",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "mx-[10px] mb-[30px] mt-[50px] text-center text-xl font-bold text-fontBackground",
      children: formattedCollectionName
    }), isVerticalScroll ?
    /*#__PURE__*/
    // Vertical grid layout
    (0,jsx_runtime.jsx)("div", {
      className: "grid grid-cols-2 gap-x-3",
      children: products.map(function (product) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(StoreItem/* default */.Z, {
          cohort: cohort,
          product: product,
          pageSize: products.length
        }, product.id);
      })
    }) :
    /*#__PURE__*/
    // Horizontal scroll layout
    (0,jsx_runtime.jsx)("div", {
      className: "hide-scrollbar flex flex-row gap-4 overflow-x-auto overflow-y-hidden whitespace-nowrap",
      children: products.map(function (product) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(StoreItem/* default */.Z, {
          cohort: cohort,
          usedForCollectionhome: true,
          product: product,
          pageSize: products.length
        }, product.id);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: collectionUrl,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        className: "mx-auto my-2 block w-[90px] border border-primary px-4 py-2 text-center text-sm text-primary transition duration-300 ease-in-out hover:bg-primary hover:text-fontPrimary",
        children: "View All"
      })
    })]
  });
};

/* harmony default export */ var Home_FeaturedCollectionWithProd = (FeaturedCollectionWithProd);
;// CONCATENATED MODULE: ./components/Home/utils.jsx



function utils_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function utils_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? utils_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : utils_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var useCollectionsQuery = function useCollectionsQuery(storeId) {
  return useQuery({
    queryKey: ["collections", storeId],
    queryFn: function () {
      var _queryFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var url, response, collections;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = "".concat(publicServerEndpoint, "/v3/collection/store/").concat(storeId, "?limit=5");
                _context.next = 3;
                return fetch(url);

              case 3:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 6;
                  break;
                }

                throw new Error("Failed to fetch collections: ".concat(response.status));

              case 6:
                _context.next = 8;
                return response.json();

              case 8:
                collections = _context.sent;

                if (collections && collections.collections && collections.collections.length === 0) {
                  collections.collections.push(ALL_PRODUCTS_OBJECT);
                }

                return _context.abrupt("return", collections.collections);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function queryFn() {
        return _queryFn.apply(this, arguments);
      }

      return queryFn;
    }(),
    enabled: !!storeId
  });
};
var useCollectionWithStoreProducts = function useCollectionWithStoreProducts(storeId) {
  var _useCollectionsQuery = useCollectionsQuery(storeId),
      collections = _useCollectionsQuery.data;

  var safeCollections = collections || [];
  var productQueries = useQueries({
    queries: safeCollections === null || safeCollections === void 0 ? void 0 : safeCollections.map(function (collection) {
      return {
        queryKey: ["collectionProducts", storeId, collection._id],
        queryFn: function () {
          var _queryFn2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            var _data$data;

            var idParam, url, response, data;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    idParam = collection._id === "all" ? "" : collection._id;
                    url = "".concat(publicServerEndpoint, "/v3/product/store/").concat(storeId, "/collectionv2?page=1&limit=10&source=web&collectionId=").concat(idParam);
                    _context2.next = 4;
                    return fetch(url);

                  case 4:
                    response = _context2.sent;

                    if (response.ok) {
                      _context2.next = 7;
                      break;
                    }

                    throw new Error("Failed to fetch products: ".concat(response.status));

                  case 7:
                    _context2.next = 9;
                    return response.json();

                  case 9:
                    data = _context2.sent;
                    return _context2.abrupt("return", ((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.docs) || []);

                  case 11:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          function queryFn() {
            return _queryFn2.apply(this, arguments);
          }

          return queryFn;
        }(),
        enabled: !!storeId
      };
    })
  });
  var combinedCollections = safeCollections.map(function (collection, index) {
    var _productQueries$index, _productQueries$index2;

    return {
      collection: collection,
      products: ((_productQueries$index = productQueries[index]) === null || _productQueries$index === void 0 ? void 0 : _productQueries$index.data) || [],
      isLoading: (_productQueries$index2 = productQueries[index]) === null || _productQueries$index2 === void 0 ? void 0 : _productQueries$index2.isLoading
    };
  });
  return {
    data: combinedCollections,
    loading: productQueries.some(function (query) {
      return query.isLoading;
    })
  };
};
/**
 * Fetches products for multiple collections
 * @param {string} storeId - Store ID
 * @param {Array} collections - Array of collection objects
 * @returns {Promise<Array>} - Collections with their products
 */

var fetchProductsForCollections = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(storeId, collections) {
    var productLimit,
        collectionsWithProducts,
        _args4 = arguments;
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            productLimit = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : 10;

            if (!(!collections || collections.length === 0)) {
              _context4.next = 3;
              break;
            }

            return _context4.abrupt("return", []);

          case 3:
            _context4.prev = 3;
            _context4.next = 6;
            return Promise.all(collections.map( /*#__PURE__*/function () {
              var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(collection) {
                var _data$data2, idParam, url, response, data;

                return regenerator_default().wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.prev = 0;
                        idParam = collection._id === "all" ? "" : collection._id;
                        url = "".concat(helper/* publicServerEndpoint */.v2, "/v3/product/store/").concat(storeId, "/collectionv2?page=1&limit=").concat(productLimit, "&source=web&collectionId=").concat(idParam);
                        _context3.next = 5;
                        return fetch(url);

                      case 5:
                        response = _context3.sent;

                        if (response.ok) {
                          _context3.next = 9;
                          break;
                        }

                        console.warn("Failed to fetch products for collection ".concat(collection._id, ": ").concat(response.status));
                        return _context3.abrupt("return", utils_objectSpread(utils_objectSpread({}, collection), {}, {
                          products: []
                        }));

                      case 9:
                        _context3.next = 11;
                        return response.json();

                      case 11:
                        data = _context3.sent;
                        return _context3.abrupt("return", utils_objectSpread(utils_objectSpread({}, collection), {}, {
                          products: ((_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.docs) || []
                        }));

                      case 15:
                        _context3.prev = 15;
                        _context3.t0 = _context3["catch"](0);
                        console.error("Error fetching products for collection ".concat(collection._id, ":"), _context3.t0);
                        return _context3.abrupt("return", utils_objectSpread(utils_objectSpread({}, collection), {}, {
                          products: []
                        }));

                      case 19:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, null, [[0, 15]]);
              }));

              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 6:
            collectionsWithProducts = _context4.sent;
            return _context4.abrupt("return", collectionsWithProducts);

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](3);
            console.error("Error in fetchProductsForCollections:", _context4.t0);
            return _context4.abrupt("return", collections.map(function (collection) {
              return utils_objectSpread(utils_objectSpread({}, collection), {}, {
                products: []
              });
            }));

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[3, 10]]);
  }));

  return function fetchProductsForCollections(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ./components/Home/FeaturedHome.jsx



























function FeaturedHome_capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var FeaturedHome = function FeaturedHome(_ref) {
  var _store$storeBanner, _cart$products;

  var theme = _ref.theme,
      store = _ref.store,
      updateHomeActive = _ref.updateHomeActive,
      heroMedia = _ref.heroMedia,
      heroMediaImages = _ref.heroMediaImages,
      heroMediaType = _ref.heroMediaType,
      heroTitle = _ref.heroTitle;

  var _useState = (0,react.useState)(CartStorage/* default.getInitialCart */.Z.getInitialCart()),
      cart = _useState[0],
      setCart = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isCartInitialized = _useState2[0],
      setIsCartInitialized = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      showCart = _useState3[0],
      setShowCart = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      showSideNav = _useState4[0],
      setShowSideNav = _useState4[1];

  var _useState5 = (0,react.useState)([]),
      collectionsWithProducts = _useState5[0],
      setCollectionsWithProducts = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isLoadingProducts = _useState6[0],
      setIsLoadingProducts = _useState6[1];

  var router = (0,next_router.useRouter)();

  var _useCollection = (0,useCollection/* default */.Z)(store.id, ""),
      fetchedCollections = _useCollection.data,
      isCollectionsLoading = _useCollection.isLoading;

  var collections = fetchedCollections ? fetchedCollections.collections : [];
  var featuredCollections = collections.filter(function (col) {
    return col.isFeatured && col.isActive;
  }).sort(function (a, b) {
    return a.sortOrder - b.sortOrder;
  });
  var isVerticalScroll = (theme === null || theme === void 0 ? void 0 : theme.collectionScrollDirection) === "vertical";
  var hasFeaturedCollections = featuredCollections && featuredCollections.length > 0; // Setup intersection observer for the pagination trigger element

  var _useInView = (0,react_intersection_observer_m/* useInView */.YD)({
    threshold: 0.1,
    // Trigger when at least 10% of the element is visible
    triggerOnce: false
  }),
      ref = _useInView.ref,
      inView = _useInView.inView; // Initialize cart


  (0,react.useEffect)(function () {
    var initialize = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var initialCartData;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return CartStorage/* default.initializeCart */.Z.initializeCart();

              case 2:
                initialCartData = _context.sent;
                setCart(initialCartData);
                setIsCartInitialized(true);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function initialize() {
        return _ref2.apply(this, arguments);
      };
    }();

    initialize();
  }, []);

  var updateAndSaveCart = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(newCartData) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setCart(newCartData);
              _context2.next = 3;
              return CartStorage/* default.saveCart */.Z.saveCart(newCartData);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function updateAndSaveCart(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var updateAddedToCart = function updateAddedToCart(productId, value) {
    console.log("FeaturedHome: Product ".concat(productId, " added status: ").concat(value, " (update logic needed)"));
  };

  var handleShowCart = function handleShowCart() {
    var boolVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setShowCart(boolVal);
  }; // Fetch collections with pagination


  var _usePaginatedCollecti = (0,useCollection/* usePaginatedCollections */.b)(store.id),
      collectionsData = _usePaginatedCollecti.data,
      isCollectionsInitialLoading = _usePaginatedCollecti.isLoading,
      isFetchingNextPage = _usePaginatedCollecti.isFetchingNextPage,
      fetchNextPage = _usePaginatedCollecti.fetchNextPage,
      hasNextPage = _usePaginatedCollecti.hasNextPage; // Process newly loaded collections to fetch their products


  (0,react.useEffect)(function () {
    if (!collectionsData) return;

    var processCollections = /*#__PURE__*/function () {
      var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
        var newCollections, processedCollectionIds, collectionsToProcess, collectionsWithProductsData;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Get all collections from all pages
                newCollections = collectionsData.pages.flatMap(function (page) {
                  return page.collections || [];
                }); // Find only collections that haven't been processed yet by comparing IDs

                processedCollectionIds = new Set(collectionsWithProducts.map(function (col) {
                  return col._id;
                }));
                collectionsToProcess = newCollections.filter(function (newCol) {
                  return !processedCollectionIds.has(newCol._id);
                });

                if (!(collectionsToProcess.length === 0)) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return");

              case 5:
                setIsLoadingProducts(true);
                _context3.prev = 6;
                _context3.next = 9;
                return fetchProductsForCollections(store.id, collectionsToProcess, isVerticalScroll ? 4 : undefined);

              case 9:
                collectionsWithProductsData = _context3.sent;
                setCollectionsWithProducts(function (prev) {
                  return [].concat((0,toConsumableArray/* default */.Z)(prev), (0,toConsumableArray/* default */.Z)(collectionsWithProductsData.filter(function (newCol) {
                    return !processedCollectionIds.has(newCol._id);
                  })));
                });
                _context3.next = 16;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](6);
                console.error("Error fetching products for collections:", _context3.t0);

              case 16:
                _context3.prev = 16;
                setIsLoadingProducts(false);
                return _context3.finish(16);

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[6, 13, 16, 19]]);
      }));

      return function processCollections() {
        return _ref4.apply(this, arguments);
      };
    }();

    processCollections();
  }, [collectionsData, store.id, collectionsWithProducts]); // Load more collections when observer element comes into view
  // Only trigger when inView and we have more pages and we're not already loading

  (0,react.useEffect)(function () {
    if (inView && hasNextPage && !isFetchingNextPage && !isLoadingProducts) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, fetchNextPage, isFetchingNextPage, isLoadingProducts]); // Combined loading state
  // const isLoading = isCollectionsInitialLoading || isFetchingNextPage || isLoadingProducts;
  // Render loading skeletons

  var renderLoadingSkeletons = function renderLoadingSkeletons(key) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "m-5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
        className: "mx-auto mb-[30px] mt-[50px] h-8 w-28 text-center font-bold text-primary"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "hide-scrollbar flex flex-row gap-4 overflow-x-auto overflow-y-hidden whitespace-nowrap",
        children: Array(2).fill(0).map(function (_, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(SkeletonCard/* default */.Z, {
            className: "m-[4px_5px_5px_4px] w-[10px] rounded-[50px] px-5 py-[4px]",
            imageClass: "w-[calc((var(--max-width)/1.5)-50px)] h-[calc((var(--max-width)/1.5)-50px)]"
          }, i);
        })
      })]
    }, key);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StaticInfoBanner, {
      text: store === null || store === void 0 ? void 0 : (_store$storeBanner = store.storeBanner) === null || _store$storeBanner === void 0 ? void 0 : _store$storeBanner.text
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "sticky top-0 w-full ".concat(heroMediaType === "image" ? "h-full" : "relative", " z-50 flex justify-center"),
      children: [isCartInitialized && (cart === null || cart === void 0 ? void 0 : (_cart$products = cart.products) === null || _cart$products === void 0 ? void 0 : _cart$products.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Basket/* default */.Z, {
        isBasketOpen: showCart,
        setCart: updateAndSaveCart,
        cartData: cart,
        updateAddedToCart: updateAddedToCart,
        handleShowCart: handleShowCart,
        store: store,
        setRefresh: function setRefresh() {}
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar/* default */.Z, {
        cartActive: isCartInitialized && cart.products.length > 0,
        hideInAdvance: false,
        homeActive: true,
        storeName: heroTitle,
        handleShowCart: handleShowCart,
        store: store,
        theme: theme,
        toggleSideNav: function toggleSideNav() {
          return setShowSideNav(!showSideNav);
        },
        homePage: true
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SideNavDrawer/* default */.Z, {
        isOpen: showSideNav,
        toggleDrawer: function toggleDrawer() {
          return setShowSideNav(!showSideNav);
        },
        store: store
      })]
    }), heroMediaType === "image" ? /*#__PURE__*/(0,jsx_runtime.jsx)(js/* Carousel */.lr, {
      autoPlay: true,
      infiniteLoop: true,
      showThumbs: false,
      showArrows: false,
      showStatus: false,
      className: (0,utils.cn)((featured_home_module_default()).carouselImageContainer),
      onClickItem: function onClickItem() {
        return router.push("/shop");
      },
      children: heroMediaImages.map(function (imageUrl) {
        var _store$cohort;

        var imageName = imageUrl.substring(imageUrl.lastIndexOf("/") + 1);
        var imgurlNew = (_store$cohort = store.cohort) !== null && _store$cohort !== void 0 && _store$cohort.includes(1) ? "https://ik.imagekit.io/dm2asset/dm2assetfull/".concat(imageName) : "https://dm2buy-resize-dynamic-cebdcaefgydgh6hu.z02.azurefd.net/dm2buy/".concat(imageName, "?width=500&quality=80");
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: imgurlNew,
            alt: imageName,
            className: "h-full w-full object-cover pb-8"
          })
        }, imageName);
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "relative h-screen max-h-[90vh] w-full",
      onClick: function onClick() {
        return router.push("/shop");
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((lib_default()), {
        url: heroMedia,
        playing: true,
        loop: true,
        muted: true,
        playsinline: true,
        width: "100%",
        height: "100%",
        className: (featured_home_module_default()).carouselVideoContainer
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "z-10 mt-2.5 flex w-full flex-col items-center",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        onClick: function onClick() {
          return updateHomeActive(false);
        },
        className: "flex h-10 w-36 items-center justify-center rounded-md bg-primary text-sm text-fontPrimary",
        children: "SHOP NOW"
      })
    }), hasFeaturedCollections && /*#__PURE__*/(0,jsx_runtime.jsx)(Home_FeaturedCollectionList, {
      featuredCollections: featuredCollections,
      isLoading: isCollectionsLoading
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "min-h-[400px] w-full",
      children: isCollectionsInitialLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: Array(2).fill(0).map(function (_, index) {
          return renderLoadingSkeletons("initial-skeleton-".concat(index));
        })
      }) : collectionsWithProducts.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [collectionsWithProducts.map(function (collection) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Home_FeaturedCollectionWithProd, {
            cohort: store.cohort,
            collectionName: FeaturedHome_capitalizeFirstLetter(collection.name ? collection.name : ""),
            themeData: theme,
            productsData: collection.products || []
          }, collection._id);
        }), (isFetchingNextPage || isLoadingProducts) && renderLoadingSkeletons("loading-more-skeleton"), hasNextPage && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: ref,
          className: "h-12 w-full",
          "aria-hidden": "true"
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex h-full items-center justify-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-gray-500"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Reviews_Reviews, {
      storeId: store.id
    })]
  });
};

/* harmony default export */ var Home_FeaturedHome = (FeaturedHome);
;// CONCATENATED MODULE: ./components/Home/ScrollPositionProvider.jsx

 // Create the context


var ScrollContext = /*#__PURE__*/(0,react.createContext)(); // Create a provider component

var ScrollProvider = function ScrollProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react.useState)(0),
      scrollPosition = _useState[0],
      setScrollPosition = _useState[1];

  var updateScrollPosition = (0,react.useCallback)(function (position) {
    setScrollPosition(position);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ScrollContext.Provider, {
    value: {
      scrollPosition: scrollPosition,
      updateScrollPosition: updateScrollPosition
    },
    children: children
  });
}; // Custom hook to use the ScrollContext

var useScroll = function useScroll() {
  var _useState2 = useState(0),
      scrollPosition = _useState2[0],
      setScrollPosition = _useState2[1];

  useEffect(function () {
    var savedPosition = localStorage.getItem("scrollPosition");

    if (savedPosition) {
      setScrollPosition(parseInt(savedPosition, 10));
    }
  }, []);

  var updateScrollPosition = function updateScrollPosition(position) {
    localStorage.setItem("scrollPosition", position);
    setScrollPosition(position);
  };

  return {
    scrollPosition: scrollPosition,
    updateScrollPosition: updateScrollPosition
  };
};
;// CONCATENATED MODULE: ./components/Home/MainHome.jsx







var MainHome = function MainHome(_ref) {
  var _store$homePage, _store$homePage2, _store$homePage3;

  var store = _ref.store,
      theme = _ref.theme,
      hideHeroMedia = _ref.hideHeroMedia;
  var router = (0,next_router.useRouter)();
  var homeActive = !!(store !== null && store !== void 0 && store.homePageEnabled) && !hideHeroMedia;

  var updateHomeActive = function updateHomeActive() {
    router.push("/shop");
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("main", {
    className: "w-screen max-w-app flex-auto bg-background transition-[max-height] duration-200",
    children: [homeActive ? /*#__PURE__*/(0,jsx_runtime.jsx)(Home_FeaturedHome, {
      theme: theme,
      store: store,
      updateHomeActive: updateHomeActive,
      heroMedia: store === null || store === void 0 ? void 0 : (_store$homePage = store.homePage) === null || _store$homePage === void 0 ? void 0 : _store$homePage.heroMedia.url,
      heroMediaImages: store === null || store === void 0 ? void 0 : (_store$homePage2 = store.homePage) === null || _store$homePage2 === void 0 ? void 0 : _store$homePage2.heroMediaImages,
      heroMediaType: store === null || store === void 0 ? void 0 : (_store$homePage3 = store.homePage) === null || _store$homePage3 === void 0 ? void 0 : _store$homePage3.heroMediaType,
      heroTitle: store.homePage.heroTitle ? store.homePage.heroTitle : store.storeName
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ScrollProvider, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Home_CollectionHome, {
        store: store,
        theme: theme
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {
      theme: theme
    })]
  });
};

/***/ }),

/***/ 3046:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carouselImageContainer":"featured-home_carouselImageContainer__ksnob","carouselImage":"featured-home_carouselImage__3aVoz","carouselVideoContainer":"featured-home_carouselVideoContainer__Pz41Z"};

/***/ }),

/***/ 3405:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"infobanner":"static-infobanner_infobanner__FrEI3"};

/***/ })

}]);